export function querySelectorSafe(root, selector) {
  try {
    return root.querySelector(selector);
  } catch {
    return null;
  }
}
export function querySelectorAllSafe(root, selector) {
  try {
    return Array.from(root.querySelectorAll(selector));
  } catch {
    return [];
  }
}
export function slugifyHeadingText(text) {
  return text.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");
}
export function ensureUniqueHeadingId(heading, usedIds, isTaken = id => document.getElementById(id) !== null) {
  if (heading.id) {
    usedIds.add(heading.id);
    return heading.id;
  }
  const base = slugifyHeadingText(heading.textContent || "") || "section";
  let id = base;
  let suffix = 2;
  while (usedIds.has(id) || isTaken(id)) {
    id = `${base}-${suffix}`;
    suffix += 1;
  }
  heading.id = id;
  usedIds.add(id);
  return id;
}
export function trackingLineY(scrollRoot, scrollOffset) {
  if (scrollRoot instanceof HTMLElement) {
    return scrollRoot.getBoundingClientRect().top + scrollOffset;
  }
  return scrollOffset;
}
export function scrollHeadingIntoView(heading, scrollRoot, scrollOffset, behavior) {
  if (scrollRoot instanceof HTMLElement) {
    const rootRect = scrollRoot.getBoundingClientRect();
    const headingRect = heading.getBoundingClientRect();
    scrollRoot.scrollTo({
      top: scrollRoot.scrollTop + (headingRect.top - rootRect.top) - scrollOffset,
      behavior
    });
    return;
  }
  window.scrollTo({
    top: window.scrollY + heading.getBoundingClientRect().top - scrollOffset,
    behavior
  });
}